import type { MessagingGetChatMessages200PageAllOfThreeContentItem } from './messagingGetChatMessages200PageAllOfThreeContentItem';

export type MessagingGetChatMessages200PageAllOfThree = {
  /** 채팅 메시지 목록 */
  content?: MessagingGetChatMessages200PageAllOfThreeContentItem[];
};
